import { normalizeFilename } from '@/api/prompts'
import type { DiffResult } from '@/types/diff'

// What the Prompts screen's delete button can do for one file. DELETE only
// ever removes the draft copy (PRD 29), so for a file in the live bundle it
// can never remove the file itself - only throw away a draft edit.
//
// - 'draft-only': not in the live bundle - Delete removes the file.
// - 'published-unchanged': draft text equals live - nothing to delete.
// - 'published-modified': draft text differs from live - DELETE reverts it.
// - 'unknown': the diff is still loading, failed, or has no entry for this
//   file - never guess, so the button stays disabled.
export type PromptDeleteState = 'draft-only' | 'published-unchanged' | 'published-modified' | 'unknown'

// Read from the same live-vs-draft diff Diff & Validation shows (exact text
// equality server-side, gui_backend/core/diff.py::_diff_prompt), so the two
// screens never disagree about whether a prompt is modified - a whitespace-
// or trailing-newline-only change counts as modified on both.
export function getPromptDeleteState(filename: string, diff: DiffResult | undefined): PromptDeleteState {
  const entry = diff?.prompts.find((prompt) => prompt.filename === normalizeFilename(filename))
  switch (entry?.status) {
    case 'added':
      return 'draft-only'
    case 'unchanged':
      return 'published-unchanged'
    case 'modified':
      return 'published-modified'
    default:
      return 'unknown'
  }
}
